import React from 'react';
import { Link } from 'react-router';
import { useTheme } from '../../context/ThemeContext.jsx';

const Footer = () => {
  const { colors, spacing, fonts } = useTheme();

  const footerStyles = {
    backgroundColor: colors.surface,
    borderTop: `1px solid ${colors.border}`,
    padding: `${spacing.scale.lg} 0`,
    marginTop: 'auto',
    color: colors.text,
    fontFamily: fonts.families.primary,
    transition: 'all 0.3s ease',
    position: 'relative',
    zIndex: 10,
  };

  const footerContentStyles = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: `0 ${spacing.scale.lg}`,
    textAlign: 'center',
  };

  const linksContainerStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: spacing.scale.md,
    flexWrap: 'wrap',
    marginBottom: spacing.scale.md,
  };

  const linkStyles = {
    color: colors.textSecondary,
    fontSize: fonts.sizes.xs.desktop,
    fontFamily: fonts.families.primary,
    fontWeight: fonts.weights.medium,
    transition: 'color 0.3s ease',
  };

  const separatorStyles = {
    color: colors.border,
    fontSize: fonts.sizes.xs.desktop,
  };

  const copyrightStyles = {
    color: colors.textSecondary,
    fontSize: fonts.sizes.xs.desktop,
    fontFamily: fonts.families.primary,
    fontWeight: fonts.weights.regular,
    lineHeight: fonts.lineHeights.normal,
  };

  const hover = (e) => (e.currentTarget.style.color = colors.secondary);
  const unhover = (e) => (e.currentTarget.style.color = colors.textSecondary);

  return (
    <footer style={footerStyles}>
      <div style={footerContentStyles}>
        <div style={linksContainerStyles}>
          <Link to="/about" style={linkStyles} onMouseEnter={hover} onMouseLeave={unhover}>
            About
          </Link>
          <span style={separatorStyles}>|</span>
          <Link to="/contact" style={linkStyles} onMouseEnter={hover} onMouseLeave={unhover}>
            Contact
          </Link>
          <span style={separatorStyles}>|</span>
          <Link to="/privacy-policy" style={linkStyles} onMouseEnter={hover} onMouseLeave={unhover}>
            Privacy Policy
          </Link>
          <span style={separatorStyles}>|</span>
          <Link to="/terms-conditions" style={linkStyles} onMouseEnter={hover} onMouseLeave={unhover}>
            Terms &amp; Conditions
          </Link>
          <span style={separatorStyles}>|</span>
          <Link to="/sms-opt-in-out" style={linkStyles} onMouseEnter={hover} onMouseLeave={unhover}>
            SMS Information
          </Link>
        </div>
        <div style={copyrightStyles}>
          © {new Date().getFullYear()} Victoria Londe. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
